import AddLocationAlt from "@mui/icons-material/AddLocationAlt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React from "react";
import RouteControls from "./RouteControls";

interface StartEndLocationProps {
  onRouteChange: (route: {
    start: google.maps.places.PlaceResult | null;
    end: google.maps.places.PlaceResult | null;
  }) => void;
}

function StartEndLocation(props: StartEndLocationProps) {
  return (
    <Accordion disableGutters square>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography
          component="span"
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <AddLocationAlt color="warning" /> Add Start and End location
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <RouteControls onRouteChange={props.onRouteChange} />
      </AccordionDetails>
    </Accordion>
  );
}

export default StartEndLocation;
